import cx from 'classnames';
import store from '~/javascripts/store.js';
import { Component } from 'react';
import { observer } from 'mobx-react';

const DonateFormUserCampaignFields = observer(
  class DonateFormUserCampaignFields extends Component {
    errorMessageForField = (fieldName) => this.props.errors[fieldName];

    hasErrorOnField = (fieldName) => !!this.errorMessageForField(fieldName);

    onDisplayNameChange = (e) => {
      store.donateForm.displayName = e.target.value;
    };

    renderNameField = () => (
      <div className={cx({ 'ss-error': this.hasErrorOnField('display_name') })}>
        <input
          className='rounded-none rounded-t -mb-px relative'
          data-form-element='name'
          data-parsley-error-message='Please enter your name'
          data-parsley-errors-container='.user-campaign-field-errors'
          data-parsley-not-a-credit-card-number
          id={`${store.donateForm.campaignSlug}_donation_form_display_name`}
          maxLength='110'
          name='displayName'
          onChange={(e) => this.onDisplayNameChange(e)}
          placeholder={
            store.donateForm.isProfileOrCampaignDonation
              ? 'Display Name (optional)'
              : 'Display Name'
          }
          required={store.donateForm.isProfileOrCampaignDonation ? false : true}
          type='text'
          value={store.donateForm.displayName}
        />
      </div>
    );

    renderCommentField = () => (
      <div className={cx({ 'ss-error': this.hasErrorOnField('comment') })}>
        <textarea
          className='rounded-none rounded-b -mt-px'
          data-form-element='comment'
          data-parsley-error-message='We think you may have entered your credit card number in the wrong field by accident.'
          data-parsley-not-a-credit-card-number
          id={`${store.donateForm.campaignSlug}_donation_form_comment`}
          name='comment'
          onChange={(e) => (store.donateForm.comment = e.target.value)}
          placeholder='Leave a note (optional)'
          type='text'
          value={store.donateForm.comment}
        />
      </div>
    );

    renderAnonymousField = () => (
      <div className='input-wrapper anonymous custom-check mt-2'>
        <input
          data-form-element='isAnonymous'
          defaultChecked={store.donateForm.isAnonymous}
          id={`${store.donateForm.campaignSlug}_donation_form_anonymous`}
          onChange={(e) => (store.donateForm.isAnonymous = e.target.checked)}
          type='checkbox'
        />
        <label
          htmlFor={`${store.donateForm.campaignSlug}_donation_form_anonymous`}
        >
          Hide my name on this page
        </label>
      </div>
    );

    commentSubheader = () => {
      const campaignOwnerName =
        store.donateForm.profileCampaignId &&
        (store.donateForm.profileOwnerName || store.donateForm.teamName || '');
      const leadText = campaignOwnerName
        ? `Your note will show up on ${campaignOwnerName}&rsquo;s campaign. `
        : '';

      return `${leadText}To leave your note anonymously, leave the display name&nbsp;blank.`;
    };

    render() {
      return (
        <div className='mt-3 border border-solid border-grey-30 pt-2 mb-2 rounded'>
          <div className='px-2'>
            <h4>Leave a note</h4>
            {store.donateForm.isProfileOrCampaignDonation && (
              <p
                className='mt-1'
                dangerouslySetInnerHTML={{ __html: this.commentSubheader() }}
              />
            )}
          </div>

          <div className='px-2 mt-4 pt-2 bg-grey-5 pb-1 rounded-b'>
            <div className='-mt-3'>{this.renderNameField()}</div>
            {this.renderCommentField()}
            <div className='user-campaign-field-errors ss-error'>
              <small className='error ss'>
                {this.errorMessageForField('display_name')}
              </small>
              <small className='error ss'>
                {this.errorMessageForField('comment')}
              </small>
            </div>
            {!store.donateForm.isProfileOrCampaignDonation &&
              this.renderAnonymousField()}
          </div>
        </div>
      );
    }
  }
);

export default DonateFormUserCampaignFields;
